<div class="content">
  <div class="layout-auto-1 md3-card-on-surface">
    <div></div>
    <div>
      <ejs-spreadsheet #spreadsheet height="100%"
                       [id]="'calc' + calcId"
                       (created)="created()" allowSave="true" listSeparator=";"

                       locale="de"

                       [saveUrl]="service + '/save'"

                       [allowOpen]="true"
                       [openUrl]="service + '/open'"

                       [enableClipboard]="true"
                       [allowCellFormatting]="true"

                       (contextMenuBeforeOpen)="contextOpen($event)"
                       (contextMenuItemSelect)="contextSelect($event)"

                       (select)="onCellSelected($event)"

                       (cellSave)="onCellSave()"
                       (actionComplete)="onActionComplete()"

                       [allowEditing] = "!readOnly">
      </ejs-spreadsheet>
    </div>
  </div>
</div>
